import React, { useEffect, useRef, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { CancelButton, SubmitButton } from "../../components/btns";
import { errorAlert, successAlert } from "../../components/toastr";
import { createVehicle, updateVehicle } from "../../resources/api/vehicles";
import { getCategories } from "../../resources/api/vehicle-categories";
import SelectInput from "../../components/select";



const { Control, Label } = Form;

/**
 * @param {Object} props
 * @param {"create"|"edit"} props.action
 * @param {(details: import("../../resources/api/vehicles").VehicleObject) => void} props.onUpload
 * @param {{
 *  show: boolean
 *  setShow: React.Dispatch<React.SetStateAction<boolean>>
 * }} props.show
 * @param {{
 *  details: import("../../resources/api/vehicles").VehicleObject
 *  setDetails: React.Dispatch<React.SetStateAction<import("../../resources/api/vehicles").VehicleObject>>
 * }} props.vehicleDetails
 */
const VehicleForm = ({ onUpload, action = "create", vehicleDetails, show: toShow }) => {

    const inputref = useRef();

    const { show, setShow } = toShow;
    const [categories_loaded, setCategoriesLoaded] = useState(false);
    const [vehicle_categories, setVehicleCategories] = useState([]);
    const [handlingSubmit, setHandlingSubmit] = useState(false);
    const [validated, setValidated] = useState(false);

    const { details, setDetails } = vehicleDetails;

    useEffect(() => {
        //set the category limits

    }, [details.category_id])


    useEffect(() => {

        if (!show) return;

        if (categories_loaded) return;

        //get categories then set categories loaded to true

        getCategories()
            .then(({ categories }) => {
                setVehicleCategories(categories);
                successAlert("Loaded vehicle categories");
            })
            .catch(e => errorAlert(`Failed to load vehicle categories... ${e}`))
            .finally(() => setCategoriesLoaded(true));

    }, [show, categories_loaded])



    /**
     * Handles the submission of the form
     * @param {React.MouseEvent} e 
     */
    const handleSubmit = e => {

        e.preventDefault();
        const form = inputref.current;

        if (!form.checkValidity()) {
            setValidated(true);
            errorAlert("Some errors have been detected in the form. These have been highlighted for you.", "Invalid Fields");
            return;
        }

        setHandlingSubmit(true);
        setValidated(false);

        let promise;

        if (action === "create") {
            promise = createVehicle(details);
        } else {
            promise = updateVehicle(details, details.id);
        }

        promise
            .then(({ vehicle, message }) => {
                form.reset();
                successAlert(message);
                onUpload(vehicle);
                setShow(false);
            })
            .catch(e => errorAlert(e))
            .finally(() => setHandlingSubmit(false))
    }

    return (
        <Modal show={show} onExit={() => setValidated(false)} centered animation={false} size="lg">
            <Modal.Body>
                <Form noValidate validated={validated} ref={inputref}>

                    <Row className="g-1">
                        <Col sm={6} className="my-1">
                            <Label className="form-field-title">Category</Label>
                            <SelectInput
                                value={[details.category_id]}
                                onChange={([id]) => setDetails(d => ({ ...d, category_id: id || "" }))}
                                options={vehicle_categories}
                                required
                                placeholder='-'
                                maxItems={1}
                                errorText="This field is required"
                            />
                        </Col>
                        <Col sm={6} className="my-1">
                            <Label className="form-field-title">Registration Number</Label>
                            <Control
                                value={details.registration_no}
                                onChange={e => setDetails({ ...details, registration_no: e.currentTarget.value?.toUpperCase() })}
                                required
                            />
                            <Control.Feedback type="invalid">
                                Required & Should be higher than min year
                            </Control.Feedback>
                        </Col>
                    </Row>


                    <Row className="g-1">
                        <Col xs={6} sm={4} className="my-1">
                            <Label className="form-field-title">Code</Label>
                            <Control
                                value={details.code}
                                onChange={e => setDetails({ ...details, code: e.currentTarget.value })}
                                required
                            />
                            <Control.Feedback type="invalid">
                                Required
                            </Control.Feedback>
                        </Col>
                        <Col xs={6} sm={4} className="my-1">
                            <Label className="form-field-title">Year</Label>
                            <Control
                                value={details.manufacture_year}
                                type="number"
                                onChange={e => setDetails({ ...details, manufacture_year: e.currentTarget.value })}
                                required
                            />
                            <Control.Feedback type="invalid">
                                Required
                            </Control.Feedback>
                        </Col>
                        <Col xs={6} sm={4} className="my-1">
                            <Label className="form-field-title">Colour</Label>
                            <Control
                                value={details.colour}
                                onChange={e => setDetails({ ...details, colour: e.currentTarget.value })}
                                required
                            />
                            <Control.Feedback type="invalid">
                                Required
                            </Control.Feedback>
                        </Col>
                    </Row>

                    <Row className="g-1">
                        <Col xs={6} sm={4} className="my-1">
                            <Label className="form-field-title">Engine No</Label>
                            <Control
                                value={details.engine_no}
                                onChange={e => setDetails({ ...details, engine_no: e.currentTarget.value })}
                            />
                        </Col>
                        <Col xs={6} sm={4} className="my-1">
                            <Label className="form-field-title">Chassis No</Label>
                            <Control
                                value={details.chassis_no}
                                onChange={e => setDetails({ ...details, chassis_no: e.currentTarget.value })}
                            />
                        </Col>
                        <Col xs={6} sm={4} className="my-1">
                            <Label className="form-field-title">Logbook No</Label>
                            <Control
                                value={details.logbook_no}
                                onChange={e => setDetails({ ...details, logbook_no: e.currentTarget.value })}
                            />
                        </Col>
                    </Row>



                    <Row>
                        <Col className="mt-4 mb-0 text-end">
                            <SubmitButton isSubmitting={handlingSubmit} onClick={handleSubmit}>
                                {action === "edit" ? "Update" : "Submit"}
                            </SubmitButton>
                            <CancelButton isSubmitting={handlingSubmit} onClick={() => setShow(false)}>
                                Cancel
                            </CancelButton>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
        </Modal >
    )
}



export default VehicleForm;